module.exports = __webpack_public_path__ + "img/refresh.23b1a80c.svg";